/* Clip & Carry article enhancements. Runs once per article page, touches only the
   article body. Everything here is additive: posts that already carry a hand-written
   .cc-toc / .cc-related keep it untouched. */
(function () {
  var body = document.querySelector('.article-template__content');
  if (!body) return;

  var slug = function (s) {
    return s.toLowerCase().replace(/&amp;|&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  };

  /* 1. Anchor every h2, then build a table of contents if the post has none. */
  var h2s = Array.prototype.slice.call(body.querySelectorAll('h2'));
  var used = {};
  h2s.forEach(function (h) {
    if (!h.id) {
      var id = slug(h.textContent) || 'section';
      var n = 1, cand = id;
      while (used[cand] || document.getElementById(cand)) cand = id + '-' + (++n);
      h.id = cand;
    }
    used[h.id] = true;
  });
  if (!body.querySelector('.cc-toc') && h2s.length >= 3) {
    var toc = document.createElement('div');
    toc.className = 'cc-toc';
    var items = h2s.map(function (h) {
      return '<li><a href="#' + h.id + '">' + h.textContent.trim() + '</a></li>';
    }).join('');
    toc.innerHTML = '<strong>In this guide</strong><ol>' + items + '</ol>';
    h2s[0].parentNode.insertBefore(toc, h2s[0]);
  }

  /* 2. Wrap tables so wide compare tables scroll sideways on phones. */
  Array.prototype.forEach.call(body.querySelectorAll('table'), function (t) {
    if (t.parentNode.classList && t.parentNode.classList.contains('cc-table-wrap')) return;
    var w = document.createElement('div');
    w.className = 'cc-table-wrap';
    t.parentNode.insertBefore(w, t);
    w.appendChild(t);
  });

  /* 3. Style the FAQ block: the h3/p pairs after "Frequently asked questions". */
  h2s.forEach(function (h) {
    if (!/^frequently asked/i.test(h.textContent.trim())) return;
    var el = h.nextElementSibling;
    while (el && el.tagName !== 'H2') {
      if (el.tagName === 'H3') el.classList.add('cc-faq-q');
      else if (el.tagName === 'P') el.classList.add('cc-faq-a');
      el = el.nextElementSibling;
    }
  });

  /* 4. Turn a plain "Related reading" h3 + link paragraph into the .cc-related block. */
  if (!body.querySelector('.cc-related')) {
    Array.prototype.forEach.call(body.querySelectorAll('h3'), function (h) {
      if (!/^related reading/i.test(h.textContent.trim())) return;
      var wrap = document.createElement('div');
      wrap.className = 'cc-related';
      h.parentNode.insertBefore(wrap, h);
      var next = h.nextElementSibling;
      wrap.appendChild(h);
      if (next && next.tagName === 'P') wrap.appendChild(next);
    });
  }
})();
